import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { ServicesService } from '../services.service';

@Injectable()
export class AuthGuard  {
  constructor(private router: Router, private _services: ServicesService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {

    const rota: Router = this.router;
    const SessionInfo: any = this._services.getLocalStorage('plataformaWeb');

    if (SessionInfo !== false) {
      const tbody: string = '{"tokenId": "' + SessionInfo.token + '", "secret": "' + SessionInfo.secret + '"}';
      // valida Token
      return this._services.checkToken(JSON.parse(tbody)).pipe(
        map(gToken => {
          if (!gToken.sucesso) {
            console.warn('APP Autenticação: ' + gToken.message);
            rota.navigate(['/login']);
          }
          return gToken.sucesso;
        })
      );
    } else {
      console.warn('Lat. Bela Vista: Autenticação Inválida!');
      rota.navigate(['/login']);
      return false;
    }
  }
}
